import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    fab: {
      position: 'fixed',
      right: theme.spacing(2),
      // Position it above actions to avoid having to render
      // it outside of it's logical container
      bottom: '72px',
    },
    checkBadge: {
      marginRight: theme.spacing(1),
      '& .MuiBadge-badge': {
        border: 'none',
        padding: '0 0px',
        fontSize: '0.55em',
        height: '1.5em',
        minWidth: '1.5em',
        lineHeight: '1.5em',
        bottom: '0.5em',
        right: '0.5em',
        backgroundColor: theme.palette.divider,
        color: theme.palette.text.primary,
      },
    },
  };
};
